import * as React from "react"
import { Row } from "react-grid-system"
import { HorizontalSpacer, Spacer } from "../../atoms/spacers"
import { useSuggestedGroupsUser } from "../../../hooks/useSuggestedGroupsUser"
import { formatGroups } from "../../../utils/formatters"
import PrimaryButton from "../../atoms/buttons/PrimaryButton"
import { CrossIcon } from "../../atoms/icons/CrossIcon"
import GroupSelectionSection from "../GroupSelectSection"
import ButtonTextSmall from "../../atoms/typography/ButtonTextSmall"

interface Props {
  memberName: string
  userId: string | undefined
  onCloseModal: () => void
  onClickInviteMemberToGroup: (id: number | string) => void
}

const InviteToGroupModalContent: React.FunctionComponent<Props> = ({
  memberName,
  userId,
  onCloseModal,
  onClickInviteMemberToGroup,
}) => {
  const onClickInviteToSelectedGroups = (id: string | number) => {
    onClickInviteMemberToGroup(id)
  }

  const { suggestedGroupsUser } = userId ? useSuggestedGroupsUser(userId) : { suggestedGroupsUser: null }
  const formattedGroups = formatGroups(suggestedGroupsUser ?? [])

  return (
    <>
      <ButtonTextSmall textAlign="left">Invite {memberName} to group:</ButtonTextSmall>
      <HorizontalSpacer spacing={2} />
      <div style={{ maxHeight: 600, overflowY: "scroll" }}>
        {formattedGroups.map((group, index) => (
          <div key={`${group.id} ${index}`}>
            <GroupSelectionSection
              groupName={group.groupName}
              members={group.members}
              terminals={group.terminals}
              onClickInviteToSelectedGroups={() => onClickInviteToSelectedGroups(group.id)}
            />
            <HorizontalSpacer spacing={1} />
          </div>
        ))}
      </div>
      <Row justify="center">
        <Spacer spacing={0.5} />
        <PrimaryButton title="Cancel" icon={<CrossIcon />} onClick={onCloseModal} />
      </Row>
    </>
  )
}

export default InviteToGroupModalContent
